<template>
  <div role="tabpanel" :id="id" class="panel-collapse collapse" :class="{'in': !collapsed}">
    <div class="panel-body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "collapse-content",
  props: {
    id: {
      type: String,
      required: true
    },
    collapsed: {
      type: Boolean,
      default: true,
      required: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Collapse/CollapseContent.vue